import styled from "styled-components";
import { Link } from "react-router-dom";

export const FooterSection = styled("footer")`
  background: rgb(241, 242, 243);
  padding: 2.5rem 0;
`;

export const Title = styled("h4")`
  font-size: 22px;
  text-transform: capitalize;
  color: #18216d;

  @media screen and (max-width: 414px) {
    padding: 1.5rem 0;
  }
`;

export const NavLink = styled(Link)`
  display: block;
  font-size: 1rem;
  margin-bottom: 0.625rem;
  transition: all 0.2s ease-in-out;

  &:hover,
  &:active,
  &:focus {
    color: #15418e;
  }
`;

export const Extra = styled.section`
  background-color: white;
  color: black;
  padding-top: 1%;
  position: relative;
  z-index: 10;
  
  @media screen and (max-width: 768px) {
    padding: 1rem 0;
    margin-top: auto;
  }
  
  .max-w-6xl {
    max-width: 1280px;
    margin: auto;
    display: flex;
    flex-wrap: wrap;
    justify-content: space-between;
    border-top: 1px solid #707070;
    align-items: top;
    padding: 0.5% 0;
    
    @media screen and (max-width: 768px) {
      padding: 1rem 0;
      flex-direction: column;
      gap: 0.5rem;
    }
  }

  .footer-section {
    text-align: left;
    padding-left: 1%;
    display: flex;
    align-items: left;
    flex-direction: column;
    padding: 0;
  }

  .Copyright {
    font-size: 16px;
    color: black;
    text-decoration: none;
    font-weight: bold;
  }

  .icp-link {
    font-size: 8px;
    color: white;
    text-decoration: none;
  }

  .icp-link-black {
    font-size: 8px;
    color: black;
    text-decoration: none;
  }

  .back-to-top {
    display: flex;
    justify-content: center;
    align-items: top;
    text-decoration: none;
    cursor: pointer;
    color: #666;
    padding: 10px;
    width: 100%;
    background: none;
    border: none;

    &:hover {
      color: black;
      text-decoration: underline;
    }
    
    @media screen and (max-width: 768px) {
      padding: 0.5rem;
      font-size: 14px;
    }
  }

  .right-section {
    display: flex;
    flex-direction: column;
    align-items: flex-end;
    padding-right: 1%;

    a {
      color: black;
      text-decoration: none;

      &:hover {
        color: #666;
        text-decoration: underline;
      }
    }
  }

  .social-links {
    display: flex;
    flex-direction: row;
    align-items: center;
    justify-content: flex-end;
    flex-wrap: wrap;
    gap: 0.85rem;

    a {
      display: inline-flex;
      align-items: center;
      color: #000;
      text-decoration: none;
      transition: color 0.2s ease-in-out;

      svg {
        width: 0.85em;
        height: 0.85em;
        flex-shrink: 0;
      }

      &:hover {
        color: #ff3b30;
      }
    }

    @media screen and (max-width: 768px) {
      justify-content: flex-start;
    }
  }
`;

export const LogoContainer = styled("div")`
  display: flex;
  position: relative;
`;

export const Para = styled("div")`
  color: #18216d;
  font-size: 14px;
  width: 70%;
`;

export const Large = styled(Link)`
  font-size: 16px;
  color: #000;
  cursor: pointer;
  transition: all 0.2s ease-in-out;
  text-transform: capitalize;
  line-height: 24px;
  display: block;
  margin-bottom: 0.625rem;
  transition: all 0.3s ease-in-out;
  max-width: max-content;

  &:hover {
    color: rgb(255, 130, 92);
    text-underline-position: under;
    text-decoration: rgb(255, 130, 92) wavy underline;
  }
`;

export const Chat = styled("p")`
  color: #18216d;
  max-width: fit-content;
  border-bottom: 1px solid #18216d;
  cursor: pointer;
  margin-top: 1rem;
  transition: all 0.3s ease-in-out;

  &:hover {
    border-bottom: 1px solid rgb(255, 130, 92);
    color: rgb(255, 130, 92);
  }
`;

export const Empty = styled("div")`
  position: relative;
  height: 53px;
`;

export const FooterContainer = styled("div")`
  max-width: 510px;
  width: 100%;
  display: flex;
  justify-content: space-between;
  text-align: center;
  align-items: center;
  transition: all 0.1s ease-in-out;

  a {
    &:hover,
    &:active,
    &:focus {
      -webkit-transform: scale(1.1);
      -ms-transform: scale(1.1);
      transform: scale(1.1);
    }
  }

  @media screen and (max-width: 769px) {
    width: auto;

    a:not(:last-child) {
      display: none;
    }
  }

  div {
    cursor: pointer;
    margin-right: 15px;
    width: 25px;
    height: 25px;

    &:hover {
      fill: rgb(255, 130, 92);
    }
  }
`;

export const Language = styled("h4")`
  font-size: 22px;
  text-transform: capitalize;
  color: #18216d;

  @media screen and (max-width: 414px) {
    padding: 1.5rem 0;
  }
`;

export const Label = styled("label")`
  font-size: 22px;
  text-transform: capitalize;
  color: #18216d;
  display: block;
  margin-bottom: 2rem;
  font-family: "Motiva Sans Bold", serif;

  @media screen and (max-width: 414px) {
    padding: 1.5rem 0;
    margin-bottom: 1rem;
  }
`;

export const LanguageSwitch = styled("div")`
  cursor: pointer;
  transition: all 0.1s ease-in-out;

  &:hover,
  &:active,
  &:focus {
    -webkit-transform: scale(1.1);
    -ms-transform: scale(1.1);
    transform: scale(1.1);
  }
`;


export const LanguageSwitchContainer = styled("div")`
  display: flex;
  justify-content: space-between;
  width: 85px;
`;

export const FooterStyle = styled("div")`
  background-color: black;
  color: white;
  padding-top: 1%;
`;

export const MaxWidthContainer = styled("div")`
  max-width: 1280px;
  margin: auto;
  display: flex;
  flex-wrap: wrap;
  justify-content: space-between;
  border-top: 1px solid #707070;
  align-items: top;
  padding: 0.5% 0;
`;

export const FooterSectionStyled = styled("div")`
  text-align: left;
  padding-left: 1%;
  display: flex;
  align-items: left;
  flex-direction: column;
  padding: 0;
`;

export const Copyright = styled("span")`
  font-size: 16px;
  color: white;
  text-decoration: none;
  font-weight: bold;
`;

export const IcpLink = styled("a")`
  font-size: 8px;
  color: white;
  text-decoration: none;
`;

export const IcpLinkBlack = styled(IcpLink)`
  color: black;
`;

export const BackToTop = styled("a")`
  display: flex;
  justify-content: center;
  align-items: top;
  text-decoration: none;
  cursor: pointer;
  color: #ccc;
  padding: 10px;
  width: 100%;

  &:hover {
    color: white;
    text-decoration: underline;
  }
`;

export const RightSection = styled("div")`
  display: flex;
  flex-direction: column;
  align-items: flex-end;
  padding-right: 1%;

  a {
    color: white;
    text-decoration: none;

    &:hover {
      color: #ccc;
      text-decoration: underline;
    }
  }
`;




